function emptyFn() {}
const windowGlobal = () => typeof window !== 'undefined' && window
const URL = windowGlobal()?.URL || emptyFn
export { windowGlobal, URL }
